import {
  APPROVAL_BORDER_RADIUS_LG,
  APPROVAL_BORDER_RADIUS_CARD,
  APPROVAL_BG_MEDIUM,
  APPROVAL_BG_LIGHT,
  APPROVAL_BG_WHITE
} from 'styles/shared/ApprovalStyleUtils';
import { cardHeaderStyle, cardContentStyle } from 'styles/shared/CardStyle';

export const ruleFormHeaderStyle = cardHeaderStyle;

export const ruleStepIndicatorStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '1.125rem',
  height: '1.125rem',
  borderRadius: '50%',
  backgroundColor: '#078DEE',
  color: 'white',
  fontSize: '0.625rem',
  fontWeight: 700,
  opacity: 1
} as const;

export const fallbackStepIndicatorStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '1.125rem',
  height: '1.125rem',
  borderRadius: '50%',
  backgroundColor: '#078DEE',
  color: 'white',
  fontSize: '0.625rem',
  fontWeight: 700,
  opacity: 1
} as const;

export const ruleFormContentStyle = cardContentStyle;

export const defaultModeButtonStyles = {
  borderRadius: '0.75rem',
  boxShadow: 'none',
  textTransform: 'none',
  '&:hover': {
    boxShadow: 'none'
  }
} as const;

export const defaultModeButtonColors = {
  color: '#6b7280',
  borderColor: '#e5e7eb'
};

export const autoApproveAlertStyle = {
  gap: '0.5rem',
  backgroundColor: APPROVAL_BG_WHITE,
  padding: '0 0.875rem 0.875rem 0.875rem',
  borderBottomLeftRadius: APPROVAL_BORDER_RADIUS_LG,
  borderBottomRightRadius: APPROVAL_BORDER_RADIUS_LG,
  '& .MuiSvgIcon-root': {
    color: '#2e7d32'
  },
  '& .MuiTypography-root': {
    color: '#1e4620'
  }
} as const;

export const autoApproveAlertContentStyle = {
  display: 'flex',
  gap: '0.75rem',
  alignItems: 'center',
  width: '100%',
  padding: '0.375rem 1rem',
  backgroundColor: '#edf7ed',
  borderRadius: APPROVAL_BORDER_RADIUS_CARD
} as const;

export const noConditionsAlertStyle = {
  gap: '0.5rem',
  backgroundColor: APPROVAL_BG_WHITE,
  padding: '0.875rem',
  borderRadius: '0.375rem'
} as const;

export const noConditionsAlertContentStyle = {
  display: 'flex',
  gap: '0.75rem',
  alignItems: 'center',
  width: '100%',
  padding: '0.375rem 1rem',
  backgroundColor: '#fff4e5',
  borderRadius: APPROVAL_BORDER_RADIUS_CARD
} as const;

export const fallbackInfoAlertContentStyle = {
  display: 'flex',
  gap: '0.75rem',
  alignItems: 'center',
  width: '100%',
  padding: '0.375rem 1rem',
  backgroundColor: '#e5f6fd',
  borderRadius: APPROVAL_BORDER_RADIUS_CARD
} as const;

export const conditionRowContainerStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.75rem',
  padding: '0.375rem 0.875rem',
  backgroundColor: APPROVAL_BG_WHITE,
  flexWrap: 'wrap'
} as const;

export const ifTextStyle = {
  fontSize: '0.875rem',
  fontWeight: 600,
  color: '#374151',
  minWidth: '1.875rem',
  textTransform: 'uppercase'
} as const;

export const livePreviewStyle = {
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
  backgroundColor: APPROVAL_BG_LIGHT,
  borderTop: '1px solid #e5e7eb',
  padding: '0.625rem 1rem',
  borderBottomLeftRadius: APPROVAL_BORDER_RADIUS_LG,
  borderBottomRightRadius: APPROVAL_BORDER_RADIUS_LG
} as const;

export const previewTextStyle = {
  fontSize: '0.875rem',
  color: '#374151'
} as const;

export const previewContainerStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: '0.375rem',
  alignItems: 'flex-start',
  textAlign: 'left'
} as const;

export const scrollableFormContainerStyle = {
  flex: 1,
  overflowY: 'auto',
  overflowX: 'hidden',
  display: 'flex',
  flexDirection: 'column',
  gap: '0.75rem',
  padding: '1rem',
  backgroundColor: APPROVAL_BG_MEDIUM
} as const;

export const formWrapperStyle = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  border: '1px solid #e5e7eb',
  borderRadius: '1rem'
} as const;

export const stickyWrapperStyle = {
  position: 'sticky',
  top: 0,
  zIndex: 20,
  backgroundColor: APPROVAL_BG_WHITE,
  borderBottom: '1px solid #e5e7eb'
} as const;

export const stickyFormHeaderWrapperStyle = {
  borderTopLeftRadius: '1rem',
  borderTopRightRadius: '1rem'
} as const;

export const stickyLivePreviewWrapperStyle = {
  borderBottomLeftRadius: '1rem',
  borderBottomRightRadius: '1rem'
} as const;

// Approval mode section styles
export const modeButtonsContainerStyle = {
  display: 'flex',
  gap: '0.5rem',
  padding: '0.875rem',
  backgroundColor: APPROVAL_BG_WHITE
} as const;

export const sequentialContainerStyle = {
  padding: '0 0.875rem 0.875rem 0.875rem',
  backgroundColor: APPROVAL_BG_WHITE
} as const;

export const parallelContainerStyle = {
  padding: '0 0.875rem 0.875rem 0.875rem',
  backgroundColor: APPROVAL_BG_WHITE,
  borderBottomLeftRadius: '1rem',
  borderBottomRightRadius: '1rem'
} as const;

export const approversListTitleStyle = {
  marginBottom: '0.75rem',
  textAlign: 'left',
  fontWeight: 600
} as const;

export const approverRowStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '0.5rem',
  padding: '0.375rem 0.75rem',
  borderRadius: '0.5rem',
  marginBottom: '0.5rem',
  cursor: 'grab',
  backgroundColor: '#f9fafb'
} as const;

export const approverRowInnerBoxStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem'
} as const;

export const approverChipContainerStyle = {
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.375rem',
  padding: '0.5rem',
  backgroundColor: APPROVAL_BG_WHITE,
  borderRadius: '0.5rem',
  marginBottom: '0.5rem',
  border: '1px solid #e5e7eb'
} as const;

export const approverChipStyle = {
  backgroundColor: '#078dee14',
  color: '#078dee',
  borderRadius: '0.25rem',
  '& .MuiChip-label': {
    fontSize: '0.75rem',
    color: '#078dee'
  },
  '&:hover .MuiChip-deleteIcon': {
    color: '#ef4444'
  }
} as const;

export const noApproversPlaceholderStyle = {
  color: '#c4c9d4',
  textAlign: 'left',
  width: '100%'
} as const;

export const requiredApprovalsBoxStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: '0.5rem',
  marginTop: '0.75rem'
} as const;

export const exclusiveAlertContentStyle = {
  display: 'flex',
  gap: '0.75rem',
  alignItems: 'center',
  width: '100%',
  padding: '0.375rem 1rem',
  backgroundColor: '#fff4e5',
  borderRadius: APPROVAL_BORDER_RADIUS_CARD
} as const;

export const fallbackWarningContentStyle = {
  display: 'flex',
  gap: '0.75rem',
  alignItems: 'flex-start',
  width: '100%',
  padding: '0.375rem 1rem',
  backgroundColor: '#fff4e5',
  borderRadius: APPROVAL_BORDER_RADIUS_CARD,
  textAlign: 'left'
} as const;

export const fallbackWarningIconStyle = {
  color: '#ed6c02',
  flexShrink: 0
} as const;

export const disabledStepIndicatorStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '1.125rem',
  height: '1.125rem',
  borderRadius: '50%',
  backgroundColor: '#d1d5db',
  color: 'white',
  fontSize: '0.625rem',
  fontWeight: 700
} as const;
